import * as GuestbookCommentTrashActionTypes from '../../../constants/comments/GuestbookCommentTrashActionTypes';

const initialState = {
    searchKeyword: '',
    searchType: 'writer',
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GuestbookCommentTrashActionTypes.CLEAR_ITEMS:
            return {
                searchKeyword: '',
                searchType: 'writer',
            };
        case GuestbookCommentTrashActionTypes.SEARCH_KEYWORD:
            return Object.assign({}, state, {
                searchKeyword: action.searchKeyword,
                searchType: action.searchType,
            });
        default :
            return state;
    }
}
